export const FitnessLevel = {
  0: "Bajo",
  1: "Medio",
  2: "Alto"
};

export const MuscleStrengthToFitnessLevel = {
  "Bajo": 0,
  "Medio": 1,
  "Alto": 2
};

export const WorkoutType = {
  0: "Clásico",
  1: "Circuito",
  2: "Tabata",
  3: "Aeróbico"
};

export const AvatarCount = {
  1: "Individual",
  2: "En pareja"
};

// Historical note: the product hierarchy was flipped after launch.
// `Admin` is the top-level role; `SuperUser` is one level below, despite
// what the names suggest. The UI labels `SuperUser` as "Administrador".
// Changing the stored values would require coordinated migration of
// Firestore user docs, Firebase Auth custom claims, Cloud Functions,
// and security rules across both Sandbox and Live environments, so the
// legacy strings are kept as-is.
export const Role = {
  SuperUser: "superuser",
  Admin: "admin",
  Doctor: "doctor",
  Intr23: "intr23",
  Intr25: "intr25",
  Ctrl25: "ctrl25",
  AppTester: "apptester"
};

export const AuthorizedRoles = [
  Role.SuperUser,
  Role.Admin,
  Role.Doctor,
  Role.Intr25,
  Role.Ctrl25
];

export const AdminRoles = [
  Role.SuperUser,
  Role.Admin
];

export const DoctorRoles = [
  Role.Doctor
];

export const PatientRoles = [
  Role.Intr25,
  Role.Ctrl25
];

// Used for determining pre/post pending vs countdown started/study finished.
// If glucoseFileCount.* < this value => pending; if >= this value => started/finished.
export const GlucoseFilesThreshold = 3;

export const Phase = {
  PRE: "pre",
  POST: "post"
};

export const PatientDataMode = {
  Eval: "eval",
  Edit: "edit"
};

export const ManualEntry = "ManualEntry";

export const Gender = {
  F: "F",
  M: "M"
};

/** Placeholder DOB for non-patient user documents (matches Node client defaultDOB intent). */
export const DefaultDateOfBirth = "1970-01-01";

export const QuestionnaireMode = {
  Fill: "fill",
  Embed_Fill: "embed_fill",
  View: "view"
};

export const UnityPaths = {
  QuestionnaireBack: "questionnaire-back",
  QuestionnaireSubmitted: "questionnaire-submitted"
};

export const ImageSize = {
  Medium: "Medium",
  Small: "Small"
};

export const ReminderState = {
  Inactive: -1,
  Active: 0,
  Completed: 1
};

// All reminder types are for doctors except for FillQuestionnairesPre and FillQuestionnairesPost
export const ReminderType = {
  FillQuestionnairesPre: "FillQuestionnairesPre",   // For patient (hidden in RemindersPanel)
  FillQuestionnairesPost: "FillQuestionnairesPost", // For patient (hidden in RemindersPanel)
  UploadGlucoseFilePre: "UploadGlucoseFilePre",
  UploadGlucoseFilePost: "UploadGlucoseFilePost",
  UploadGlucoseFilePreFollowUp: "UploadGlucoseFilePreFollowUp", // Hidden in RemindersPanel
  UploadGlucoseFilePostFollowUp: "UploadGlucoseFilePostFollowUp", // Hidden in RemindersPanel
  ScheduleAppointmentPost: "ScheduleAppointmentPost",
  CompletePostEval: "CompletePostEval"
};

export const ReminderMessages = {
  UploadGlucoseFilePre: "Subir archivo de glucosa/insulina pre",
  UploadGlucoseFilePost: "Subir archivo de glucosa/insulina post",
  ScheduleAppointmentPost: "Programar cita",
  CompletePostEval: "Completar evaluación post"
};

export const PatientStatusCode = {
  WITHDRAWN: "withdrawn",
  PRE_PENDING: "pre_pending",
  COUNTDOWN_NOT_STARTED: "countdown_not_started",
  POST_PENDING: "post_pending",
  STUDY_FINISHED: "study_finished",
  LOW_DAYS_REMAINING: "low_days_remaining",
  NORMAL: "normal",
  UNDETERMINED: "undetermined"
};

export const PatientStatusFilterLabels = {
  withdrawn: "Dado/a de baja",
  pre_pending: "Pre pendiente",
  countdown_not_started: "Cuenta atrás no iniciada",
  post_pending: "Post pendiente",
  study_finished: "Estudio terminado",
  low_days_remaining: "Menos de 15 días",
  normal: "Estado normal",
  undetermined: "Estado indeterminado"
};